'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of in office checkout web
 */ const InOfficeCheckoutWeb = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 107 107",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "53.5",
                cy: "53.5",
                r: "53.5",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "20.5312",
                y: "32.5332",
                width: "65.7905",
                height: "38.3176",
                rx: "3.61486",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                opacity: "0.7",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.5312 63.9116V67.2368C20.5312 69.2333 22.1497 70.8517 24.1461 70.8517H82.7069C84.7034 70.8517 86.3218 69.2333 86.3218 67.2368V63.9116H20.5312Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "43.3789",
                y: "70.8516",
                width: "20.2432",
                height: "6.21757",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "36.293",
                y: "76.9238",
                width: "34.2689",
                height: "1.73514",
                rx: "0.867568",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M30 46C30 45.4477 30.4477 45 31 45H61C61.5523 45 62 45.4477 62 46C62 46.5523 61.5523 47 61 47H31C30.4477 47 30 46.5523 30 46Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "30",
                y: "57",
                width: "47",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M30 40C30 39.4477 30.4477 39 31 39H61C61.5523 39 62 39.4477 62 40C62 40.5523 61.5523 41 61 41H31C30.4477 41 30 40.5523 30 40Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "30",
                y: "51",
                width: "47",
                height: "2",
                rx: "1",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M69.6384 43.3251L68.8443 39.7525C68.797 39.5398 68.6774 39.3476 68.5074 39.2114C68.3376 39.075 68.1241 39 67.9062 39H67.1343C67.0484 39 66.9846 39.0795 67.0033 39.1633L67.1226 39.7003C67.1369 39.7643 67.1937 39.8101 67.2595 39.8101H67.9063C67.9775 39.8101 68.0381 39.8587 68.0535 39.9282L68.8476 43.5009C68.8896 43.6896 69.057 43.8181 69.2427 43.8181C69.2718 43.8181 69.3014 43.815 69.331 43.8084C69.5494 43.7599 69.687 43.5434 69.6385 43.3251H69.6384Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M69.7057 44.3466H73.6424C73.7972 44.3466 73.93 44.2362 73.958 44.0839L74.5369 40.9414H68.6914L69.3924 44.0954C69.4251 44.2421 69.5553 44.3466 69.7057 44.3466Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M73.6435 44.7524H69.7067C69.5422 44.7524 69.3809 44.6958 69.2525 44.5927C69.1241 44.4898 69.0338 44.3446 68.998 44.184L68.1875 40.5371H74.8632C74.947 40.5371 75.0104 40.6132 74.9952 40.6956L74.3574 44.158C74.294 44.5024 73.9938 44.7524 73.6435 44.7524ZM69.7742 43.9423H73.5734L74.0514 41.3473H69.1974L69.7742 43.9423Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M73.2784 46.3419C73.7126 46.3419 74.0646 45.9899 74.0646 45.5557C74.0646 45.1215 73.7126 44.7695 73.2784 44.7695C72.8442 44.7695 72.4922 45.1215 72.4922 45.5557C72.4922 45.9899 72.8442 46.3419 73.2784 46.3419Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M70.0753 46.3419C70.5095 46.3419 70.8615 45.9899 70.8615 45.5557C70.8615 45.1215 70.5095 44.7695 70.0753 44.7695C69.6411 44.7695 69.2891 45.1215 69.2891 45.5557C69.2891 45.9899 69.6411 46.3419 70.0753 46.3419Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "65",
                y: "38",
                width: "12",
                height: "10.4",
                rx: "0.582456",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M69.516 44.1245L68.7587 40.7176C68.7137 40.5148 68.5996 40.3315 68.4375 40.2016C68.2755 40.0715 68.0719 40 67.8642 40H67.1281C67.0461 40 66.9853 40.0758 67.0031 40.1557L67.117 40.6678C67.1305 40.7289 67.1848 40.7725 67.2475 40.7725H67.8643C67.9322 40.7725 67.9899 40.8189 68.0046 40.8851L68.7619 44.2921C68.8019 44.4721 68.9616 44.5947 69.1387 44.5947C69.1664 44.5947 69.1946 44.5916 69.2229 44.5853C69.4311 44.5391 69.5624 44.3327 69.5161 44.1245H69.516Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M69.5805 45.0988H73.3346C73.4823 45.0988 73.6089 44.9935 73.6356 44.8483L74.1876 41.8516H68.6133L69.2818 44.8592C69.3129 44.9992 69.4371 45.0988 69.5805 45.0988Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M73.3357 45.4866H69.5816C69.4246 45.4866 69.2708 45.4325 69.1484 45.3343C69.0259 45.2361 68.9398 45.0977 68.9057 44.9445L68.1328 41.4668H74.4988C74.5788 41.4668 74.6392 41.5394 74.6247 41.618L74.0166 44.9197C73.956 45.2482 73.6698 45.4866 73.3357 45.4866ZM69.6459 44.7141H73.2688L73.7247 42.2394H69.0959L69.6459 44.7141Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M72.988 47.0014C73.4021 47.0014 73.7378 46.6658 73.7378 46.2517C73.7378 45.8376 73.4021 45.502 72.988 45.502C72.574 45.502 72.2383 45.8376 72.2383 46.2517C72.2383 46.6658 72.574 47.0014 72.988 47.0014Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M69.9335 47.0014C70.3476 47.0014 70.6833 46.6658 70.6833 46.2517C70.6833 45.8376 70.3476 45.502 69.9335 45.502C69.5194 45.502 69.1838 45.8376 69.1838 46.2517C69.1838 46.6658 69.5194 47.0014 69.9335 47.0014Z",
                fill: theme.ds5.asset[assetColor]["100"]
            })
        ]
    });
};

exports.InOfficeCheckoutWeb = InOfficeCheckoutWeb;
//# sourceMappingURL=InOfficeCheckoutWeb.cjs.map
